import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassClock } from '@fortawesome/pro-solid-svg-icons';
import {
    faCloudRain,
    faStarChristmas,
    faHandHoldingDollar,
    faThumbsUp,
    faBullhorn
} from '@fortawesome/pro-regular-svg-icons';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: '100%'
        },
        description: {
            fontSize: '16px',
            fontWeight: 600
        },
        summary: {
            fontSize: '15px'
        },
        list: {
            listStyleType: 'none',
            padding: 0,
            margin: 0
        },
        listItem: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '12px',
            color: '#333',
            fontSize: '16px'
        },
        icon: {
            width: '24px',
            marginRight: '10px',
            color: '#555'
        }
    })
);

const SMSDescription = () => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <p className={classes.description}>Engage your clients with high-performing SMS marketing. Try sending:</p>
            <ul className={classes.list}>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faCloudRain}
                        className={classes.icon}
                    />
                    Rainy Day Reminders
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faStarChristmas}
                        className={classes.icon}
                    />
                    Holiday-Themed Promotions
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faHandHoldingDollar}
                        className={classes.icon}
                    />
                    Price Increase Notices
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faHourglassClock}
                        className={classes.icon}
                    />
                    Last-Minute Availability
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faThumbsUp}
                        className={classes.icon}
                    />
                    Customer Appreciation Messages
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faBullhorn}
                        className={classes.icon}
                    />
                    New Service Announcements
                </li>
                <p className={classes.summary}>
                    Tap into one of the most effective direct marketing channels with open rates as high as 98%.
                </p>
            </ul>
        </Box>
    );
};

export default SMSDescription;
